import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SoundManager} from "../../sound/SoundManager";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class BookOfShadowsSpinReelPartAnimator extends SpinReelPartAnimator {

    /**
     * @inheritDoc
     * @override To set the gold land state in free spin mode.
     */
    protected fadeOutSymbolBlur(): void {
        const state: ISymbolStateConfig = BookOfShadowsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? BookOfShadowsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : BookOfShadowsGameConfig.instance.SYMBOL_STATES.normal,
            goldLandState: ISymbolStateConfig = BookOfShadowsGameConfig.instance.SYMBOL_STATES.goldLand,
            fsSpecialSymbol: string = BookOfShadowsGameConfig.instance.FS_SPECIAL_SYMBOL,
            symsNumInReel: number[] = BookOfShadowsGameConfig.instance.SYMBOLS_NUM_IN_REEL,
            rowDiff: number = (5 - BookOfShadowsGameConfig.instance.ACTIVE_ROWS);

        let isSpecialSymbol: boolean;

        // this is restricted only to the visible reel area i.e symId 1 to 5 in as symbolsToAnimate are 0 to 7.
        for (let i: number = (symsNumInReel[1]); i < (this._symbolsToAnimate.length - symsNumInReel[3] - 1); i++) {
            isSpecialSymbol = false;

            if ((fsSpecialSymbol !== "" && this._symbolsToAnimate[i].symName.indexOf(fsSpecialSymbol) !== -1)) {
                if (i >= (rowDiff + symsNumInReel[0] + symsNumInReel[1])) {
                    if ((GameSetting.isFastSpin || this._isQuickStop) && !BookOfShadowsGameConfig.instance.FS_SPACIAL_SYMBOL_SOUND_PLAYED) {
                        SoundManager.playFSSpecialSymbolLanding(this._reelId);
                        BookOfShadowsGameConfig.instance.FS_SPACIAL_SYMBOL_SOUND_PLAYED = true;
                    } else if ((!GameSetting.isFastSpin && !this._isQuickStop)) {
                        SoundManager.playFSSpecialSymbolLanding(this._reelId)
                    }
                }
                isSpecialSymbol = true;
            }

            this._symbolsToAnimate[i].changeState({
                state: (isSpecialSymbol) ? goldLandState : state,
                replay: false,
                fadeInDuration: BookOfShadowsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION,
                fadeInDelay: BookOfShadowsGameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY
            });
        }
    }
}